import { createStyles, Typography, WithStyles, withStyles } from '@freighthub/silhouette-core'
import cn from 'classnames'
import { FC, PropsWithChildren } from 'react'
import { I18N } from 'utils/localisation'

const jssBookingTemplateDetailRow = () =>
  createStyles({
    formRow: {
      position: 'static',
      display: 'flex',
      padding: '10px 0',
    },
    fieldLabel: {
      display: 'flex',
      alignItems: 'flex-start',
      alignSelf: 'stretch',
      flex: 'none',
      width: 100,
      marginRight: 10,
      padding: '6px 0',
    },
  })

interface IBookingTemplateDetailRowProps extends WithStyles<typeof jssBookingTemplateDetailRow, false> {
  labelTerm: string
  error?: boolean
  customClass?: string
}

const LeanBookingTemplateDetailRow: FC<PropsWithChildren<IBookingTemplateDetailRowProps>> = ({
  labelTerm,
  classes,
  error,
  customClass,
  children,
  ...other
}) => {
  return (
    <Typography
      component="div"
      color={error ? 'error' : 'textPrimary'}
      className={cn(classes.formRow, customClass)}
      {...other}
    >
      <span className={classes.fieldLabel}>
        <I18N term={labelTerm} />
      </span>
      {children}
    </Typography>
  )
}

export const BookingTemplateDetailRow = withStyles(jssBookingTemplateDetailRow)(LeanBookingTemplateDetailRow)
